<template>
    <div class="widget" v-if="$store.state.modules.indexOf('crm.company')>=0">
        <h2 class="title">Sociétés</h2>
        <div class="showbox" v-if="!companies">
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
            </div>
        </div>
        <div class="widget-content" v-if="companies">
            <i class="icon icon-icon_company"></i>
            <div class="count"><span>total</span>{{ companies.length }}</div>
        </div>

        <div class="buttons">
            <router-link :to="{name:'company'}"><span>Voir la liste</span></router-link>
            <router-link :to="{name:'company-new'}"><span>Créer</span></router-link>
        </div>
    </div>
</template>
<script>

    import PersonService from './CompanyService.js';

    export default {
        name: 'Widget',
        data () {
            return {
                companies: null
            }
        },
        mounted: function(){
            PersonService.query().then((response) => {
                this.companies = response.data.data
            })
        },
        watch: {
            '$store.getters.scope'(newId, oldId) {
                PersonService.query().then((response) => {
                    this.companies = response.data.data
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/company/CompanyWidget.vue